<template>
  <div class="card">
    <div class="card-pic">
      <img
        :src="`https://backend.upskill.com.bd${workshop.image}`"
        class="wrk-pic"
      />
    </div>
    <div>
      <div class="workshop__info">
        <p class="workshop__info-date">{{ getTime(workshop.workshop_ts) }}</p>
        <h3 class="workshop__info-title">{{ workshop.name }}</h3>
        <p class="workshop__info-speaker">
          <!--        {{ workshop.location.slice(0, 40) }}...-->
        </p>
        <div>
          <strong class="fee"
            ><span v-if="!workshop.bools.completed">{{
              workshop.fee === 0 ? 'Free' : `Tk.${workshop.fee}`
            }}</span></strong
          >
          <strong class="fee-previous fee"
            ><span v-if="workshop.bools.completed">{{
              workshop.fee === 0 ? 'Free' : `Tk.${workshop.fee}`
            }}</span></strong
          >

          <strong
            ><span class="buy-conf" v-if="canAttendWorkshop">
              <i class="fa fa-check-circle fa-lg circle"></i>
              PURCHASED</span
            ></strong
          >
          <!-- <span style="color:blue">{{
            !workshop.bools.completed
              ? getTimeLeft(workshop.workshop_ts)
              : getTimeCompleted(workshop.workshop_ts)
          }}</span> -->
        </div>
      </div>
      <div class="workshop__user_sub">
        <!--      <u-btn-b>DUE</u-btn-b>-->

        <!--        <u-btn-b class="resources-btn wrk-btn disabled" v-if="canAttendWorkshop"-->
        <!--          >Discussion</u-btn-b-->
        <!--        >-->
        <u-btn-b
          class="resources-btn wrk-btn"
          v-if="canSeeResources"
          @click.native.prevent="openResources"
          >Resources</u-btn-b
        >
        <u-btn-b
          class="zoom-btn"
          v-if="canSeeZoomLink"
          @click.prevent.native="zoomLink(workshop.id)"
          >Zoom Link</u-btn-b
        >
        <u-btn-b
          class="wrk-btn"
          v-if="canGenerateCertificate"
          :link="`https://service.upskill.com.bd${workshop.certLink}`"
          >Certificate</u-btn-b
        >
        <u-btn-b
          class="fd-btn wrk-btn"
          v-if="canGenerateFeedback"
          @click.native.prevent="feedbackForm"
          >Get Certificate</u-btn-b
        >

        <u-btn-b
          color="orange"
          textColor="black"
          class="wrk-btn due-btn"
          v-if="canPayDue"
          @click.prevent.native="GotoWS(workshop.id)"
          >Pay Due</u-btn-b
        >
      </div>
      <sweet-modal ref="resources">
        <sweet-modal-tab title="Assignments" id="tab1">
          <div v-if="wRes.assignment">
            <div
              v-for="(v, i) in wRes.assignment"
              :key="v.link"
              style="display: flex; width: 100%; justify-content: space-between; align-content: space-between; padding: 15px 5px; font-size: 18px"
            >
              <div style="font-weight: bold">Item {{ i + 1 }}</div>
              <div>
                <a :href="v.link" target="_blank">{{ v.title }}</a>
              </div>
            </div>
          </div>
          <div
            v-else
            style="display: flex; width: 100%; justify-content: space-between; align-content: space-between; padding: 15px 5px; font-size: 18px"
          >
            <div style="font-weight: bold">No assignments found!</div>
          </div>
        </sweet-modal-tab>
        <sweet-modal-tab title="Files" id="tab2">
          <div v-if="wRes.file">
            <div
              v-for="(v, i) in wRes.file"
              :key="v.link"
              style="display: flex; width: 100%; justify-content: space-between; align-content: space-between; padding: 15px 5px; font-size: 18px"
            >
              <div style="font-weight: bold">Item {{ i + 1 }}</div>
              <div>
                <a :href="v.link" target="_blank">{{ v.title }}</a>
              </div>
            </div>
          </div>
          <div
            v-else
            style="display: flex; width: 100%; justify-content: space-between; align-content: space-between; padding: 15px 5px; font-size: 18px"
          >
            <div style="font-weight: bold">No files found!</div>
          </div>
        </sweet-modal-tab>
        <sweet-modal-tab title="Videos" id="tab3">
          <div v-if="wRes.video">
            <div
              v-for="(v, i) in wRes.video"
              :key="v.link"
              style="display: flex; width: 100%; justify-content: space-between; align-content: space-between; padding: 15px 5px; font-size: 18px"
            >
              <div style="font-weight: bold">Item {{ i + 1 }}</div>
              <div>
                <a :href="v.link" target="_blank">{{ v.title }}</a>
              </div>
            </div>
          </div>
          <div
            v-else
            style="display: flex; width: 100%; justify-content: space-between; align-content: space-between; padding: 15px 5px; font-size: 18px"
          >
            <div style="font-weight: bold">No videos found!</div>
          </div>
        </sweet-modal-tab>
      </sweet-modal>
      <sweet-modal ref="zoomLinks">
        <sweet-modal-tab title="Class Link(s)" id="zoomLinks">
          <div
            v-for="(v, i) in classes"
            :key="v.id"
            style="display: flex; width: 100%; justify-content: space-between; align-content: space-between; padding: 15px 5px; font-size: 18px"
          >
            <div style="font-weight: bold">Class {{ i + 1 }}</div>
            <div><a :href="v.zoom_link" target="_blank">Click here</a></div>
            <div style="color: #01b55e">
              {{ getTime2(v.date) }} <br />
              {{ fromNow(v.date) }}
            </div>
          </div>
        </sweet-modal-tab>
      </sweet-modal>
      <!-- <div class="userCardSubTextContainer">
        <div
          v-bind:class="{
            resourcesInactive: !canSeeResources,
            userCardSubText: canSeeResources
          }"
          @click="checkResource(workshop, 'assignment')"
        >
          Assignments
        </div>
        <div
          v-bind:class="{
            resourcesInactive: !canSeeResources,
            userCardSubText: canSeeResources
          }"
          @click="checkResource(workshop, 'file')"
        >
          Files
        </div>
        <div
          v-bind:class="{
            resourcesInactive: !canSeeResources,
            userCardSubText: canSeeResources
          }"
          @click="checkResource(workshop, 'video')"
        >
          Video
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Alert from 'sweetalert2'
export default {
  props: ['workshop'],
  data() {
    return {
      classes: [],
      wRes: {},
    }
  },
  computed: {
    canGenerateFeedback() {
      return (
        this.workshop.bools.completed &&
        !this.workshop.bools.feedback &&
        this.workshop.bools.paid
      )
    },
    canGenerateCertificate() {
      return (
        this.workshop.bools.completed &&
        this.workshop.bools.feedback &&
        this.workshop.bools.paid
      )
    },
    canPayDue() {
      return (
        !this.workshop.bools.completed &&
        !this.workshop.bools.paid &&
        this.workshop.fee != 0
      )
    },
    canAttendWorkshop() {
      return (
        // (!this.workshop.bools.completed && this.workshop.bools.paid) ||
        // this.workshop.fee == 0
        this.workshop.bools.paid || this.workshop.fee == 0
      )
    },
    canSeeResources() {
      return this.workshop.bools.paid || this.workshop.fee == 0
    },
    canSeeZoomLink() {
      return this.workshop.bools.paid || this.workshop.fee == 0
    },
  },
  methods: {
    // Abilities
    // Time Related
    getTime(pwstime) {
      return moment(pwstime).format('ddd, DD MMMM, YYYY')
    },
    getTime2(pwstime) {
      return moment(pwstime).format('lll')
    },
    fromNow(t) {
      return moment(t).fromNow()
    },
    getTimeLeft(pwstime) {
      return moment(pwstime).fromNow()
    },
    getTimeCompleted(pwstime) {
      return moment(pwstime).format('LL')
    },
    showRes() {
      this.$emit('res', this.workshop.resources)
    },
    hiRes() {
      this.$modal.show('res')
    },
    feedbackForm() {
      this.$emit('feedback', this.workshop)
    },
    checkResource(workshop, type) {
      this.$emit('resource', { workshop, type })
    },
    feedback() {
      Alert.fire({
        input: 'textarea',
        title: 'Feedback on ' + this.workshop.name,
        inputPlaceholder: 'Please provide a feedback on the workshop...',
        inputAttributes: {
          'aria-label': 'Please provide a feedback on the workshop...',
        },
        showCancelButton: true,
      }).then((res) => {
        if (res.value) {
          this.$emit('feedback', {
            wid: this.workshop.id,
            feedback: res.value,
          })
        }
      })
    },
    GetResource(id) {
      let resJSON = { video: [], file: [], assignment: [] }
      this.$upskill.resources(id).then((res) => {
        let ws = res.data.status
        if (ws == null || ws == undefined) {
          this.SuccessAlert('No resource found!')
          return
        }
        let wres = JSON.parse(ws[0].resources)
        // console.log(wres)
        if (typeof wres != 'string') {
          wres.data.forEach((o) => {
            if (resJSON[o.type]) {
              resJSON[o.type].push(o)
            }
          })
        } else {
          this.SuccessAlert('No resource found!')
          return
        }
        this.wRes = resJSON
        this.$refs.resources.open()
      })
    },
    zoomLink(id) {
      this.$upskill.getClassesByWID(id).then((res) => {
        if (!res.data.data || res.data.data.length < 1) {
          this.SuccessAlert('No class links!')
        } else {
          this.$refs.zoomLinks.open()
          this.classes = res.data.data
        }
      })
    },
    openResources() {
      this.GetResource(this.workshop.id)
    },
  },
  created() {},
}
</script>

<style scoped>
.card {
  width: 60%;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 10px #0136861a;
  border-radius: 10px;
  display: grid;
  grid-template-columns: 1fr 3fr;
}
.wrk-pic {
  width: 250px;
  height: auto;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.buy-conf {
  color: #0062ff;
}
.circle {
  color: #0062ff;
}
.wrk-btn {
  width: 100%;
}
.fd-btn {
  background-color: #60d91a !important;
  color: whitesmoke;
}
.resources-btn {
  color: #60d91a !important;
  background-color: transparent !important;
  border: 2px solid #60d91a;
  border-radius: 4px;
}
.zoom-btn {
  color: #0062ff !important;
  background-color: transparent !important;
  border: 2px solid #60d91a;
  border-radius: 4px;
}
.userCardSubText {
  text-align: left;
  font: normal normal bold 12px Montserrat;
  margin: 15px;
  letter-spacing: 0px;
  color: #0062ff;
  text-transform: uppercase;
  opacity: 1;
}
.userCardSubText:hover {
  color: #000000;
  text-decoration: underline;
}
.userCardSubTextContainer {
  display: flex;
  justify-content: space-between;
}
.workshop__user_sub {
  align-content: center;
  /* display: -webkit-box;
  display: -ms-flexbox; */
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  /* -webkit-box-pack: justify;
  -ms-flex-pack: justify; */
  /* justify-content: space-evenly; */
  padding: 10px 30px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.due-btn {
  width: 300px !important;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600 !important;
}
.fee {
  font-size: 18px;
}
.fee-previous {
  padding-right: 1em;
}
.resourcesInactive {
  text-align: left;
  font: normal normal bold 12px Montserrat;
  margin: 15px;
  letter-spacing: 0px;
  color: #9aa7be;
  text-transform: uppercase;
  opacity: 1;
}
.sweet-modal ul.sweet-modal-tabs li.sweet-modal-tab.active a {
  color: rgb(13, 0, 128) !important;
}
@media only screen and (max-width: 600px) {
  .card {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .card-pic {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .wrk-pic {
    width: 285px;
    height: auto;
    margin-top: 1em;
  }
  .workshop__user_sub {
    display: flex;
    flex-wrap: wrap;
    padding: 1em;
    justify-content: space-between;
  }
  .workshop__user_sub a {
    max-width: 100% !important;
    margin-bottom: 0.5em;
  }
  .due-btn {
    width: 285px !important;
    height: auto !important;
  }
}
</style>
